import React, {FC} from "react"

import {H4, Body} from "@irati/ui/src/Typography"
import {Radio} from "@irati/ui/src/FormItem"
import Link from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"

import {options} from "../../../../../account/src/constants/contactPreferences"

interface Props extends InjectIntl {
  onChange: (value: string) => void,
  value: boolean
}

const ContactPreferences: FC<Props> = ({onChange, value = null, formatMessage}) => {
  const link = (
    <Link href={formatMessage({id: "onboarding.contactPreferences.link.href"})} target="_blank">
      {formatMessage({id: "onboarding.contactPreferences.link.text"})}
    </Link>
  )

  return (
    <Flex direction="column" marginBottom={3}>
      <H4 marginBottom={1}>
        <FormattedMessage id="onboarding.contactPreferences.heading" />
      </H4>
      <Body small marginBottom={3}>
        <FormattedMessage id="onboarding.contactPreferences.body" values={{link}} />
      </Body>
      <Radio name="marketingEmailRadio" value={value} options={options(formatMessage)} onChange={onChange} />
    </Flex>
  )
}

export default injectIntl(ContactPreferences)
